module.exports = __webpack_public_path__ + "img/if-form-rule.7843cd37.svg";